module.exports = __webpack_public_path__ + "static/media/dwnldFileManifest.bc41b77e.svg";